'use client'
import { Individualprofile } from '@/payload-types'
import Card from '../card/card'
import Image from 'next/image'
import MediaPopover from './media-popover'
import { Button } from 'flowbite-react'
import FlowbiteIconComponent from '../flowbite-icon/flowbiteIcon'

interface IProps {
  profileData?: Individualprofile
  caseId?: string
}

const CaseProfileCard = ({ profileData, caseId }: IProps) => {
  const filteredMedia = profileData?.medias?.filter(
    (m) =>
      typeof m === 'object' &&
      !(m.mimeType?.includes('video') || m.mimeType?.includes('audio')) &&
      m.belongToCase?.some((c) => typeof c === 'object' && c.id === caseId),
  )

  const imageUrl =
    typeof profileData?.publicProfile === 'object' &&
      typeof profileData?.publicProfile?.profileImage === 'object'
      ? profileData?.publicProfile?.profileImage?.sizes?.webp?.url ?? ''
      : ''
  const profileImageUrl = `${process.env.NEXT_PUBLIC_PAYLOAD_URL ? process.env.NEXT_PUBLIC_PAYLOAD_URL : ''
    }${imageUrl}`
  const profileSlug =
    typeof profileData?.publicProfile === 'object' ? profileData?.publicProfile?.slug : ''
  const isProfessor = profileData?.status?.includes('Professor')
  const profileUrl = `/${isProfessor ? 'professor' : 'individual'}/${profileSlug}`

  return (
    <Card className="drop-shadow-md flex justify-start items-start sm:gap-4 gap-2 lg:h-[100px] h-[120px] mr-2">
      <Image
        src={profileImageUrl}
        alt={profileData?.fullName ?? ''}
        width={85}
        height={80}
        className="rounded-lg h-full object-cover w-[100px] md:w-[85px]"
      />
      <div className="flex flex-col justify-between h-full flex-1 min-w-0 overflow-hidden">
        <div className="flex">
          <div className="text-md font-bold  whitespace-nowrap truncate">
            {profileData?.fullName}
          </div>
        </div>
        <div className="flex lg:gap-4 gap-2 justify-between lg:flex-row flex-col">
          {filteredMedia && filteredMedia?.length > 0 ? (
            <MediaPopover filteredMedia={filteredMedia} />
          ) : (
            <div className="h-[30px] rounded-lg border border-gray-600 border-2 lg:text-sm text-xs flex items-center justify-center flex-1">
              No Media
            </div>
          )}
          <Button
            href={profileUrl}
            className={`py-0 flex items-center border-0 !ring-0 bg-black flex-1 h-[30px] reportButton`}
            target='_blank'>
            <div className={`flex items-center justify-center text-sm font-medium leading-[21px] lg:text-sm text-xs whitespace-nowrap`}>See Profile</div>
            <FlowbiteIconComponent iconType="ArrowRight" />
          </Button>
        </div>
      </div>
    </Card>
  )
}

export default CaseProfileCard
